import { Checkbox, Input, Stack } from "@adfenix/alexandria";
import { AgentService } from "@adfenix/types";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import { getHqById } from "api/services";
import { SearchLocation } from "components/Location/SearchLocation";

export const Coordinates = ({
  agentData
}: {
  agentData: AgentService.AgentModel;
}) => {
  const [enableMap, setEnableMap] = useState(false);
  const { setValue, watch, register } =
    useFormContext<AgentService.AgentModel>();

  const { data: hq } = useQuery(["get-hq-by-id", agentData.primaryHqId], () =>
    getHqById(agentData.primaryHqId)
  );
  const [latitude, longitude] = watch([
    "coordinates.latitude",
    "coordinates.longitude"
  ]);

  return (
    <Stack spacing="m">
      <Checkbox
        label="Use map"
        onChange={() => setEnableMap(!enableMap)}
        name="enable-coordinates"
      />

      <Input label="Latitude" {...register("coordinates.latitude")} />
      <Input label="Longitude" {...register("coordinates.longitude")} />

      {enableMap && hq?.country && (
        <SearchLocation
          hqCountry={hq.country}
          customCoordinates={{ latitude, longitude }}
          setCustomCoordinates={({ latitude, longitude }) => {
            setValue("coordinates.latitude", latitude);
            setValue("coordinates.longitude", longitude, {
              shouldDirty: true
            });
          }}
        />
      )}
    </Stack>
  );
};
